import React from 'react';

const TherapeuticApplications = ({
  formData,
  handleInputChange,
  commonStyles,
  colors
}) => {
  return (
    <div style={{
      backgroundColor: colors?.surface || '#fff',
      padding: '24px',
      borderRadius: '12px',
      marginBottom: '24px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <h3 style={{
        color: colors?.text?.primary || '#1a202c',
        fontSize: '1.2rem',
        fontWeight: '700',
        marginBottom: '20px',
        paddingBottom: '10px',
        borderBottom: `2px solid ${colors?.primary || '#29458d'}`
      }}>Therapeutic Applications Schedule (Optional)</h3>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '20px'
      }}>
        <div>
          <label style={{ 
            fontSize: '1rem', 
            fontWeight: 'bold',
            color: colors.tool1,
            display: 'block',
            marginBottom: '8px'
          }}>
            First Therapeutic Application
          </label>
          <input
            type="number"
            name="hoursBeforeRun1"
            value={formData?.hoursBeforeRun1 || ''}
            onChange={handleInputChange}
            step="0.25"
            min="0"
            placeholder="Hours before run"
            style={{...commonStyles.input}}
          />
        </div>

        <div>
          <label style={{ 
            fontSize: '1rem', 
            fontWeight: 'bold',
            color: colors.tool2,
            display: 'block',
            marginBottom: '8px'
          }}>
            Second Therapeutic Application
          </label>
          <input
            type="number"
            name="hoursBeforeRun2"
            value={formData?.hoursBeforeRun2 || ''}
            onChange={handleInputChange}
            step="0.25"
            min="0"
            placeholder="Hours before run"
            style={{...commonStyles.input}}
          />
        </div>

        <div>
          <label style={{ 
            fontSize: '1rem', 
            fontWeight: 'bold',
            color: colors.tool3,
            display: 'block',
            marginBottom: '8px'
          }}>
            Third Therapeutic Application
          </label>
          <input
            type="number"
            name="hoursBeforeRun3"
            value={formData?.hoursBeforeRun3 || ''}
            onChange={handleInputChange}
            step="0.25"
            min="0"
            placeholder="Hours before run"
            style={{...commonStyles.input}}
          />
        </div>
      </div>
    </div>
  );
};

export default TherapeuticApplications; 